(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-scripts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',e=>{const toggle=e.target.closest('.menu-toggle');if(toggle){const nav=document.getElementById('navigation');if(!nav)return;const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));nav.classList.toggle('open',open)}const link=e.target.closest('nav a');if(link){document.querySelector('.menu-toggle')?.setAttribute('aria-expanded','false');document.getElementById('navigation')?.classList.remove('open')}const card=e.target.closest('[data-format]');if(card){const field=document.getElementById('format');if(field)field.value=card.dataset.format}});document.addEventListener('keydown',e=>{if(e.key==='Escape'){const nav=document.getElementById('navigation');if(nav?.classList.contains('open')){nav.classList.remove('open');const toggle=document.querySelector('.menu-toggle');toggle?.setAttribute('aria-expanded','false');toggle?.focus()}}});
  } catch(e) { console.error(e); }
})();

})();
